import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";
import { hasPerm } from "@/lib/auth";

const tabs = [
  { lines: ["Incomplete", "Profile"], to: "/actions/customers/incomplete-profile" },
  { lines: ["Pending", "Customers"], to: "/actions/customers/pending-customers" },
  { lines: ["Active", "Customers"], to: "/actions/customers/customers" },
  { lines: ["Rejected", "Customers"], to: "/actions/customers/rejected-customers" },
  { lines: ["Move", "Customers", "Profile"], to: "/actions/customers/move-customers-profile", perm: "move-customers" }, // 👈 your permission here}, // want to add permission here
];

const visibleTabs = tabs.filter(
  (tab) => !tab.perm || hasPerm(tab.perm)
);

export function ActionCustomerMenu() {
  return (
    <div className="bg-card border border-border rounded-xl p-1 sm:p-2 lg:p-3">
      {/* 
        Mobile: grid (2 cols)
        Tablet: flex row (wrap if needed) + 2-line labels
        Desktop: centered row + 1-line labels
      */}
      <div
        className={cn(
          // mobile
          "grid grid-cols-2 gap-2",

          // tablet (no scroll, allow wrap if tight)
          "md:flex md:flex-wrap md:gap-2 md:justify-center",

          // desktop
          "lg:flex-nowrap lg:justify-center"
        )}
      >
        {visibleTabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) =>
              cn(
                // base
                "uppercase rounded-xl border transition-all duration-200",
                "flex items-center justify-center text-center",

                // mobile
                "min-h-[56px] px-2 py-2 text-[11px] leading-tight",

                // tablet: slightly smaller, still 2-line
                "md:min-h-[52px] md:px-3 md:py-2 md:text-[12px] md:rounded-xl",

                // desktop: pill + single line
                "lg:min-h-0 lg:h-10 lg:px-4 lg:py-2 lg:text-sm lg:rounded-full lg:whitespace-nowrap",

                isActive
                  ? "bg-primary text-primary-foreground border-primary/30 shadow-sm"
                  : "bg-background text-muted-foreground border-border hover:text-foreground hover:bg-muted"
              )
            }
          >
            <span className="font-semibold">
              {/* Mobile + Tablet: multi-line */}
              <span className="block lg:hidden">
                {tab.lines.map((t, i) => (
                  <span key={i} className="block">
                    {t}
                  </span>
                ))}
              </span>

              {/* Desktop: single line */}
              <span className="hidden lg:inline">{tab.lines.join(" ")}</span>
            </span>
          </NavLink>
        ))}
      </div>
    </div>
  );
}